import React from 'react';

const AuthLayout = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen bg-primary text-white flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 bg-secondary rounded-2xl overflow-hidden border border-gray-border shadow-2xl">
        <div
          className="hidden lg:flex flex-col justify-between p-10 bg-cover bg-center relative"
          style={{ backgroundImage: 'url(/assets/images/LoginBackground.png)' }}
        >
          <div className="absolute inset-0 bg-black/70" />
          <div className="relative">
            <img src="/assets/images/BKFC.png" alt="BKFC" className="h-8 w-auto" />
            <p className="text-sm text-text-muted mt-4">
              The Home of Bare Knuckle Fighting Championship
            </p>
          </div>
          <div className="relative space-y-4">
            <h2 className="text-3xl font-bold font-heading">Watch Live Events and Replays</h2>
            <p className="text-gray-300">
              Access premium BKFC content, manage profiles, and continue watching from any device.
            </p>
          </div>
          <div className="relative text-sm text-accent font-semibold uppercase tracking-wide mt-4">
            Welcome to BKFC+
          </div>
        </div>

        <div className="p-6 sm:p-10 bg-primary/70">
          <div className="mb-8 lg:hidden">
            <img src="/assets/images/BKFC.png" alt="BKFC" className="h-8 w-auto" />
          </div>
          <h1 className="text-3xl font-semibold font-heading">{title}</h1>
          {subtitle && <p className="text-text-muted mt-2 mb-8">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
